import { api } from "./client";
import type {
  CheckoutSessionResponse,
  FreeTrialConfig,
  Plan,
  PlanType,
  UserAccessStatus,
} from "@/types";

export async function getPlans(): Promise<Plan[]> {
  return api.get<Plan[]>("/subscriptions/plans");
}

export async function getMyAccessStatus(): Promise<UserAccessStatus> {
  return api.get<UserAccessStatus>("/subscriptions/me");
}

export async function createCheckoutSession(plan_type: PlanType): Promise<CheckoutSessionResponse> {
  return api.post<CheckoutSessionResponse>("/payments/create-checkout", { plan_type });
}

export async function cancelSubscription() {
  return api.post("/subscriptions/cancel");
}

export async function getFreeTrialConfig(): Promise<FreeTrialConfig> {
  return api.get<FreeTrialConfig>("/admin/free-trial-config");
}

export async function updateFreeTrialConfig(data: Partial<FreeTrialConfig>): Promise<FreeTrialConfig> {
  return api.put<FreeTrialConfig>("/admin/free-trial-config", data);
}

export async function startFreeTrial() {
  return api.post("/attempts/free-trial");
}

export async function verifyCheckout(session_id: string, plan_type: string) {
  return api.post("/payments/verify-checkout", { session_id, plan_type });
}
